/**
 * 財務管理（會計審核）路由 — 請款單／憑證列表與詳情。
 * 新增／編輯在個人中心（填單人操作），此處只放審核用的列表與詳情。
 */
import { Navigate } from 'react-router';

import {
  FMS_PAYMENT_REQUEST_READ_CODES,
  FMS_VOUCHER_READ_CODES,
} from '#/config/permissions';
import { ROUTES } from '#/config/routes';
import PaymentRequestDetailPage from '#/modules/finMgmt/claims/pages/PaymentRequestDetailPage';
import PaymentRequestListPage from '#/modules/finMgmt/claims/pages/PaymentRequestListPage';
import PaymentRequestVoucherDetailPage from '#/modules/finMgmt/claims/pages/PaymentRequestVoucherDetailPage';
import VoucherDetailPage from '#/modules/finMgmt/vouchers/pages/VoucherDetailPage';
import VoucherListPage from '#/modules/finMgmt/vouchers/pages/VoucherListPage';
import RequirePermission from '#/modules/infra/auth/RequirePermission';

export const fmsRoutes = [
  {
    path: 'fms-mgmt',
    handle: { title: '財務管理' },
    children: [
      {
        index: true,
        element: <Navigate to={ROUTES.fmsPaymentRequest} replace />,
      },
      {
        path: 'payment-requests',
        handle: { title: '請款單' },
        element: (
          <RequirePermission codes={FMS_PAYMENT_REQUEST_READ_CODES} mode="any" />
        ),
        children: [
          {
            index: true,
            element: <PaymentRequestListPage />,
          },
          {
            path: ':id',
            handle: { title: '請款單詳情' },
            element: <PaymentRequestDetailPage mode="finance" />,
          },
          {
            path: ':id/vouchers/:voucherId',
            handle: { title: '引用憑證' },
            element: <PaymentRequestVoucherDetailPage mode="finance" />,
          },
        ],
      },
      {
        path: 'vouchers',
        handle: { title: '憑證' },
        element: (
          <RequirePermission codes={FMS_VOUCHER_READ_CODES} mode="any" />
        ),
        children: [
          {
            index: true,
            element: <VoucherListPage />,
          },
          {
            path: ':id',
            handle: { title: '憑證詳情' },
            element: <VoucherDetailPage mode="finance" />,
          },
        ],
      },
    ],
  },
];
